import React from 'react';
export function Divider() {
  return <div className="flex items-center gap-3 px-6" data-id="element-56">
      <div className="flex-1 h-px bg-cream-dark" data-id="element-57"></div>
      <span className="text-[16px] opacity-40" data-id="element-58">✦</span>
      <div className="flex-1 h-px bg-cream-dark" data-id="element-59"></div>
    </div>;
}